import React, { useEffect, useState } from 'react';
import './settings.scss';
import { useDispatch } from 'react-redux';
import { applyCoupon, getPlans, getAccountDetail, validateCoupon, createCheckout } from '../../Redux/ActionCreators/settingAction';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getSubscriptionPlans } from '../../Redux/ActionCreators/userAction';
import { userDetails } from '../../Redux/ActionCreators/authAction';

const MONTHLY_PLAN_IDS = [
    'f0915a8b-f05f-4e1c-9487-e1832477f1b0', // Starter Monthly
    '7d8beda3-f6a2-422e-a6ff-e7022ad77e89', // Growth Monthly
    '4e7fafea-f3dd-40d0-934d-775fe729880b', // Scale Monthly
];

const TIER_PLAN_IDS = {
    1: 'f0915a8b-f05f-4e1c-9487-e1832477f1b0', // Starter Monthly
    2: '7d8beda3-f6a2-422e-a6ff-e7022ad77e89', // Growth Monthly
    3: '4e7fafea-f3dd-40d0-934d-775fe729880b', // Scale Monthly
};

const PLAN_TIERS = {
    'f1b9c601-b562-4be5-8550-f3d7628ac8cc': 0, // Free
    'f0915a8b-f05f-4e1c-9487-e1832477f1b0': 1, // Starter Monthly
    '86d70a3f-046a-4d5c-a004-85dec22d004b': 1, // Starter Annual
    '7d8beda3-f6a2-422e-a6ff-e7022ad77e89': 2, // Growth Monthly
    'afaafbea-31b8-46d1-84cd-df7b29db39dd': 2, // Growth Annual
    '4e7fafea-f3dd-40d0-934d-775fe729880b': 3, // Scale Monthly
    'f5a9c9c5-2ba1-4b43-ac6d-b0ee1fda7c45': 3, // Scale Annual
};

export default function Settings() {
    const [coupon, setCoupon] = useState('');
    const [billingCycle, setBillingCycle] = useState('annual');
    const [loadingTier, setLoadingTier] = useState(null);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const tenantId = localStorage.getItem("tenentId");

    const { selectedTenant } = useSelector((state) => state.users);

    const currentPlanId = selectedTenant?.data?.subscription_plan?.id;
    const currentPlanTier = PLAN_TIERS[currentPlanId] ?? -1;
    const isCurrentPlanMonthly = MONTHLY_PLAN_IDS.includes(currentPlanId);

    useEffect(() => {
        dispatch(getSubscriptionPlans(tenantId));
        dispatch(userDetails());
        dispatch(getAccountDetail());
        // dispatch(getPlans());
    }, [])

    useEffect(() => {
        if (currentPlanId) {
            setBillingCycle(MONTHLY_PLAN_IDS.includes(currentPlanId) ? 'monthly' : 'annual');
        }
    }, [currentPlanId]);

    const changeCoupon = (val) => {
        setCoupon(val);
    }

    const handleUpgrade = async (planId, tier) => {
        setLoadingTier(tier);
        try {
            const res = await dispatch(createCheckout(planId));
            const checkoutUrl = res?.payload?.data?.checkout_url;
            const orderId = res?.payload?.data?.payment_order_id;
            if (checkoutUrl && orderId) {
                localStorage.setItem('payment_order_id', orderId);
                window.location.href = checkoutUrl;
            }
        } catch (err) {
            console.error('Checkout error:', err);
        } finally {
            setLoadingTier(null);
        }
    };

    const apply = async () => {
        const res = await dispatch(validateCoupon(coupon));
        if (res?.type === 'VALIDATE_COUPON_CODE') {
            await dispatch(applyCoupon(coupon));
            await dispatch(getAccountDetail());
            await dispatch(getPlans());
            setCoupon('');
        }
    }

    const renderPlanButton = (tier) => {
        const planId = TIER_PLAN_IDS[tier];
        const isLoading = loadingTier === tier;

        if (currentPlanTier === -1) {
            return (
                <button
                    className="btn-primary"
                    disabled={!planId || isLoading}
                    onClick={() => planId && handleUpgrade(planId, tier)}
                >
                    {isLoading ? 'Loading...' : 'Get started'}
                </button>
            );
        } else if (tier === currentPlanTier) {
            const cycleMatches = (billingCycle === 'monthly' && isCurrentPlanMonthly) ||
                (billingCycle === 'annual' && !isCurrentPlanMonthly);
            if (!cycleMatches) return null;
            return <button className="btn-primary" disabled>Current Plan</button>;
        } else if (tier > currentPlanTier) {
            return (
                <button
                    className="btn-primary"
                    disabled={!planId || isLoading}
                    onClick={() => planId && handleUpgrade(planId, tier)}
                >
                    {isLoading ? 'Loading...' : 'Upgrade'}
                </button>
            );
        }
        return null;
    };

    return (
        <div className='settings-holder'>
            <div className="bg-white payment-plans-main px-5 py-3">
                <div className="row">
                    {window.innerWidth > 767 &&
                        <div className="col-3">

                        </div>}
                    <div className={window.innerWidth > 767 ? "col-md-6" : "col-12"}>
                        <h1 className="maintxt">{t('Payment Plans Details', { ns: 'profile' })} </h1>
                    </div>

                </div>
                <div className="row py-3">
                    <div className="col-3">
                        <span className="labletext px-0">{t('Plan', { ns: 'profile' })} :</span> <span className="labletext px-0"> {selectedTenant?.data?.subscription_plan?.name}</span>
                    </div>
                    <div className="col-3">
                        <span className="labletext px-0">{t('Billing Cycle', { ns: 'profile' })} :</span> <span className="labletext px-0">{selectedTenant?.data?.subscription_plan?.billing_cycle}</span>
                    </div>
                    {selectedTenant?.data?.feature_usages?.map((usage) => (
                        <div className="col-3 mb-2" key={usage.id}>
                            <span className="labletext px-0">{usage.subscription_feature?.name} :</span>
                            <span className="labletext px-0"> {usage.remaining_count}</span>
                        </div>
                    ))}
                </div>
                {/* <div className="row py-3 align-items-center">
                    <div className='col-3'>
                        <span className="labletext px-0">{t('Additional Credits', { ns: 'profile' })} :</span>
                        <span className="labletext px-0"> {accountDetail?.additionalCreditTotalCount}</span>
                    </div>
                    <div className="col-3">
                        <span className="labletext px-0">{t('Additional Credits Left', { ns: 'profile' })} :
                        </span> <span className="labletext px-0">{accountDetail?.additionalCreditLeftCount}</span>
                    </div>
                    <div className="col-3">
                        <span className="labletext px-0">{t('Valid till Date', { ns: 'profile' })} :</span> <span className="labletext px-0">{accountDetail?.additionalCreditValidTillDate?.split('T')[0]}</span>
                    </div>
                    <div className="col-3">
                        <button className='buy-btn' onClick={openPayment}>Buy credits</button>
                    </div>
                </div> */}


                <div className="row">
                    <hr className="hr" />
                    <div className="col-12">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">
                                    <span className="labletext px-0">{t('Payment Plans', { ns: 'profile' })}</span>
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <section className="pricing-table">
                                    <div className="container">
                                        <div className="block-heading">
                                            <h2 style={{ color: '#3b8f90', fontFamily:`"Manrope", sans-serif` }}>{t('Our Pricing', { ns: 'profile' })}</h2>
                                        </div>
                                        <div className='d-flex justify-content-center'>
                                            <div className="toggle-container" data-aos="fade-up" data-aos-delay="300">
                                                <button
                                                    className={`toggle-button ${billingCycle === 'annual' ? 'active' : ''}`}
                                                    id="annual-billing"
                                                    onClick={() => setBillingCycle('annual')}
                                                >
                                                    Annual Billing<span className="discount">-20%</span>
                                                </button>
                                                <button
                                                    className={`toggle-button ${billingCycle === 'monthly' ? 'active' : ''}`}
                                                    id="monthly-billing"
                                                    onClick={() => setBillingCycle('monthly')}
                                                >
                                                    Monthly Billing
                                                </button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center" style={{padding:'0'}}>
                                                <div class="pricing-card">
                                                    <div class="pricing-header">
                                                        <div class="card-header">
                                                            <div class="plan-info">
                                                                <h3 class="plan-name">Free</h3>
                                                                <p class="plan-desc">Experience automated hiring</p>
                                                            </div>
                                                            <div class="price">
                                                                <p class="amount">$0</p>
                                                            </div>
                                                        </div>
                                                        <div class="card-actions">
                                                            <div class="started">
                                                                {renderPlanButton(0)}
                                                                <p class="plan-desc"></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body">
                                                        <ul class="features-list">
                                                            <li><i class="fas fa-check"></i> Unlimited Candidate Storage & CRM</li>
                                                            <li><i class="fas fa-check"></i> AI resume scoring - 100 (one-time)</li>
                                                            <li><i class="fas fa-check"></i> AI pre-screening - 50 (one-time)</li>
                                                            <li><i class="fas fa-check"></i> AI assessments (MCQ-based) - 20 (one-time)</li>
                                                            <li><i class="fas fa-check"></i> AI voice interviews - 5 (one-time)</li>
                                                            <li><i class="fas fa-check"></i> 1 active job</li>
                                                            <li><i class="fas fa-check"></i> Basic analytics</li>
                                                            <li><i class="fas fa-check"></i> 1 user</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center" style={{padding:'0'}}>
                                                <div class="pricing-card">
                                                    <div class="pricing-header">
                                                        <div class="card-header">
                                                            <div class="plan-info">
                                                                <h3 class="plan-name">Starter</h3>
                                                                <p class="plan-desc">For freelancers, solo recruiters, and small teams</p>
                                                            </div>
                                                            <div class="price">
                                                                <p class="amount">{billingCycle === 'annual' ? '$29' : '$39'}</p>
                                                                <p class="period">/mo</p>
                                                            </div>
                                                        </div>
                                                        <div class="card-actions">
                                                            <div class="started">
                                                                {renderPlanButton(1)}
                                                                <div class="action-info">
                                                                    {billingCycle === 'annual' && 1 >= currentPlanTier && (1 !== currentPlanTier || !isCurrentPlanMonthly) && <p class="save-annualy annual-savings">Save $120 annually</p>}
                                                                </div>
                                                            </div>
                                                            {1 >= currentPlanTier && !(billingCycle === 'annual' && 1 === currentPlanTier && isCurrentPlanMonthly) && <div><p class="trial-text">Start 14 day trial</p></div>}
                                                        </div>
                                                    </div>
                                                    <div class="card-body">
                                                        <ul class="features-list">
                                                            <li><i class="fas fa-check"></i> Unlimited Candidate Storage & CRM</li>
                                                            <li><i class="fas fa-check"></i> AI resume scoring - 200/mo</li>
                                                            <li><i class="fas fa-check"></i> AI pre-screening - 100/mo</li>
                                                            <li><i class="fas fa-check"></i> AI assessments (MCQ-based) - 25/mo</li>
                                                            <li><i class="fas fa-check"></i> AI voice interviews - 5 (one-time)</li>
                                                            <li><i class="fas fa-check"></i> 5 active jobs</li>
                                                            <li><i class="fas fa-check"></i> Basic analytics</li>
                                                            <li><i class="fas fa-check"></i> Career page</li>
                                                            <li><i class="fas fa-check"></i> 1 user</li>
                                                            <li><i class="fas fa-check"></i> Zapier & basic integrations</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center" style={{padding:'0'}}>
                                                <div class="pricing-card featured">
                                                    <div class="pricing-header">
                                                        <div class="card-header">
                                                            <div class="plan-info">
                                                                <h3 class="plan-name">Growth</h3>
                                                                <p class="plan-desc">For small and mid-sized staffing firms</p>
                                                            </div>
                                                            <div class="price">
                                                                <p class="amount">{billingCycle === 'annual' ? '$99' : '$129'}</p>
                                                                <p class="period">/mo</p>
                                                            </div>
                                                        </div>
                                                        <div class="card-actions">
                                                            <div class="started">
                                                                {renderPlanButton(2)}
                                                                <div class="action-info">
                                                                    {billingCycle === 'annual' && 2 >= currentPlanTier && (2 !== currentPlanTier || !isCurrentPlanMonthly) && <p class="save-annualy annual-savings">Save $360 annually</p>}
                                                                </div>
                                                            </div>
                                                            {2 >= currentPlanTier && !(billingCycle === 'annual' && 2 === currentPlanTier && isCurrentPlanMonthly) && <div><p class="trial-text">Start 14 day trial</p></div>}
                                                        </div>
                                                    </div>
                                                    <div class="card-body">
                                                        <ul class="features-list">
                                                            <li><i class="fas fa-check"></i> Unlimited Candidate Storage & CRM</li>
                                                            <li><i class="fas fa-check"></i> AI resume scoring - 800/mo</li>
                                                            <li><i class="fas fa-check"></i> AI pre-screening - 400/mo</li>
                                                            <li><i class="fas fa-check"></i> AI assessments (all types) - 100/mo</li>
                                                            <li><i class="fas fa-check"></i> AI voice interviews - 40/mo</li>
                                                            <li><i class="fas fa-check"></i> AI video interviews - 5 (one-time)</li>
                                                            <li><i class="fas fa-check"></i> 20 active jobs</li>
                                                            <li><i class="fas fa-check"></i> Advanced pipelines</li>
                                                            <li><i class="fas fa-check"></i> Automation workflows</li>
                                                            <li><i class="fas fa-check"></i> 5 recruiter seats</li>
                                                            <li><i class="fas fa-check"></i> Advanced analytics</li>
                                                            <li><i class="fas fa-check"></i> Email + calendar automation</li>
                                                            <li><i class="fas fa-check"></i> Add-on credits option</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center" style={{padding:'0'}}>
                                                <div class="pricing-card">
                                                    <div class="pricing-header">
                                                        <div class="card-header">
                                                            <div class="plan-info">
                                                                <h3 class="plan-name">Scale</h3>
                                                                <p class="plan-desc">For high-volume hiring & global agencies</p>
                                                            </div>
                                                            <div class="price">
                                                                <p class="amount">{billingCycle === 'annual' ? '$279' : '$349'}</p>
                                                                <p class="period">/mo</p>
                                                            </div>
                                                        </div>
                                                        <div class="card-actions">
                                                            <div class="started">
                                                                {renderPlanButton(3)}
                                                                <div class="action-info">
                                                                    {billingCycle === 'annual' && 3 >= currentPlanTier && (3 !== currentPlanTier || !isCurrentPlanMonthly) && <p class="save-annualy annual-savings">Save $840 annually</p>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body">
                                                        <ul class="features-list">
                                                            <li><i class="fas fa-check"></i> Unlimited Candidate Storage & CRM</li>
                                                            <li><i class="fas fa-check"></i> AI resume scoring - 3000/mo</li>
                                                            <li><i class="fas fa-check"></i> AI pre-screening - 1500/mo</li>
                                                            <li><i class="fas fa-check"></i> AI assessments (all types) - 400/mo</li>
                                                            <li><i class="fas fa-check"></i> AI voice interviews - 150/mo</li>
                                                            <li><i class="fas fa-check"></i> AI video interviews - 25/mo</li>
                                                            <li><i class="fas fa-check"></i> Psychometric & CEFR Assessments</li>
                                                            <li><i class="fas fa-check"></i> 50 active jobs</li>
                                                            <li><i class="fas fa-check"></i> Advanced workflows</li>
                                                            <li><i class="fas fa-check"></i> 20 recruiter seats</li>
                                                            <li><i class="fas fa-check"></i> ATS Integrations</li>
                                                            <li><i class="fas fa-check"></i> Deep analytics</li>
                                                            <li><i class="fas fa-check"></i> Open API</li>
                                                            <li><i class="fas fa-check"></i> White-label & branding*</li>
                                                            <li><i class="fas fa-check"></i> Add-on credits option</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div >
                                </section >
                            </div >
                            <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                <div className="row py-3">
                                    <div className="col-7">
                                        <input type="text" className="form-control" placeholder={t('Coupon Code', { ns: 'profile' })} name="couponcode" value={coupon} id="couponcode"
                                            onChange={(e) => changeCoupon(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-5">
                                        <button className="btn-txt1" type="button" onClick={apply} >{t('Apply', { ns: 'profile' })}</button>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div >
                </div >
            </div >
        </div >
    )
}
